import { Group, Table } from "@mantine/core"
import type { PropsWithChildren, ReactNode } from "react"

export function PreviewRow({ value, children }: PropsWithChildren<{ value: ReactNode }>) {
  return (
    <Table.Tr fz="md">
      <Table.Td c="dimmed">
        <Group gap={4} wrap="nowrap" style={{ whiteSpace: "nowrap" }}>
          {children}
        </Group>
      </Table.Td>
      <Table.Td fw={500} fz="lg" ta="left" w="70%" style={{ wordBreak: "break-word" }}>
        {value}
      </Table.Td>
    </Table.Tr>
  )
}
